export default function MultipleChoiceIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="8.25" stroke="#455468" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="5" fill="#455468" />
    </svg>
  );
}
